export const validateHaloSideDiamondFields = (filters) => {
  const fieldNames = [
    'quality_of_diamonds_on_outside_of_halo',
    'setting_style_of_diamonds_on_outside_of_halo',
    'milgrain_on_outside_of_halo'
  ]

  const fieldErrorMsgMapping = {
    'quality_of_diamonds_on_outside_of_halo': 'Quality of Diamonds on Outside Sides of Halo',
    'setting_style_of_diamonds_on_outside_of_halo': 'Setting Style of Diamonds on Outside Sides of Halo',
    'milgrain_on_outside_of_halo': 'Milgrain on Outside Sides of Halo'
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/halo-side-diamond-fields/index.js